import dayjs from "dayjs";
import { Integration } from "@/types/general";
import BaseTooltip from "@reusables/BaseTooltip";
import { Clock3 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { isPreviouslyImported } from "./importHistory";

interface ImportEntityHistoryBadgeProps {
    history?: Integration.Import.HistoryItem;
}

export default function ImportEntityHistoryBadge({ history }: ImportEntityHistoryBadgeProps) {
    const { t } = useTranslation("", { keyPrefix: "imports.reimport.badge" });

    if (!isPreviouslyImported(history)) {
        return null;
    }

    const lastImportedAt = history?.lastImportedAt ? dayjs(history.lastImportedAt) : undefined;
    const hasValidDate = lastImportedAt?.isValid() === true;

    const label = hasValidDate
        ? t("lastImported", { date: lastImportedAt!.format("DD MMM YYYY") })
        : t("previouslyImported");

    return (
        <BaseTooltip title={t("tooltip") as string} placement="top">
            <span className="inline-flex items-center gap-1 rounded-md bg-[#FFF4D8] px-2 py-[2px] text-xs font-medium text-[#8A5A00]">
                <Clock3 size={12} />
                <span>{label}</span>
            </span>
        </BaseTooltip>
    );
}
